// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041418/js/" + chunkId + "." + {"44":"e8dfcd79","225":"8eb4d6c1","481":"ecab76ab","486":"ea846ccb","770":"2cb44448"}[chunkId] + ".0.08729057934157025.chunk.js";
};